export {}

const leaflets = document.querySelectorAll(".i-leaflet")

function truncateText(element: HTMLElement, link: HTMLAnchorElement) {
  const contentElement = element.closest(".i-leaflet__content")
  if (!contentElement) return
  let perexHeight = contentElement.clientHeight

  const headerContentElement = contentElement.querySelector<HTMLElement>(".i-leaflet__header")
  if (headerContentElement) perexHeight = perexHeight - headerContentElement.clientHeight - 16

  const locationsContentElement = contentElement.querySelector<HTMLElement>(".i-leaflet__locations")
  if (locationsContentElement) perexHeight = perexHeight - locationsContentElement.clientHeight - 16

  const originalText = element.innerText

  let truncatedText = originalText
  const words = originalText.split(" ")

  while (words.length > 0) {
    element.innerText = truncatedText // Update text content
    if (element.scrollHeight > perexHeight) {
      words.pop() // Remove the last word if overflow occurs
      truncatedText = words.join(" ") + "..."

      if (link && link.classList.contains("d-none")) link.classList.remove("d-none")
    } else {
      break // Stop if the content fits
    }
  }
}

const init = () => {
  leaflets.forEach((leaflet) => {
    if (leaflet.classList.contains("--initialized")) return

    const perex = leaflet.querySelector<HTMLElement>(".i-leaflet__perex p") ?? leaflet.querySelector<HTMLElement>(".i-leaflet__perex")
    const perexLink = leaflet.querySelector<HTMLAnchorElement>(".i-leaflet__perex-link")
    const content = leaflet.querySelector<HTMLElement>(".i-leaflet__content")

    if (!perex || !perexLink || !content) return
    if (!perex.dataset.originalText) perex.dataset.originalText = perex.innerHTML

    leaflet.addEventListener("initLeaflet", () => {
      if (!leaflet.classList.contains("--initialized")) init()
    })

    if (leaflet.clientHeight < 1) return

    truncateText(perex, perexLink)

    const resizeObserver = new ResizeObserver(() => truncateText(perex, perexLink))
    resizeObserver.observe(perex)

    perexLink.addEventListener("click", (e) => {
      e.preventDefault()

      perexLink.classList.toggle("--active")
      content.classList.toggle("--active")
      const linkTitle = perexLink.querySelector(".link__title")

      if (perex.dataset.originalText) perex.innerHTML = perex.dataset.originalText

      if (!perexLink.classList.contains("--active")) truncateText(perex, perexLink)

      if (linkTitle && perexLink.classList.contains("--active") && perexLink.dataset.activeText) {
        linkTitle.innerHTML = perexLink.dataset.activeText
      } else if (linkTitle && perexLink.dataset.defaultText) {
        linkTitle.innerHTML = perexLink.dataset.defaultText
      }
    })

    leaflet.classList.add("--initialized")
  })
}

init()
